import { render } from "./TheLanguages.vue?vue&type=template&id=3de6a1db&ts=true"
import script from "./TheLanguages.vue?vue&type=script&lang=ts"
export * from "./TheLanguages.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__